
(() => {
    const FOCUSABLE = 'a, button, input, select, textarea, [tabindex]';

    function updateSlideVisibility(swiper) {
        swiper.slides.forEach((slide) => {
            const isActive = slide.classList.contains('swiper-slide-active');
            if (isActive) {
                slide.removeAttribute('aria-hidden');
                slide.querySelectorAll(FOCUSABLE).forEach((el) => el.removeAttribute('tabindex'));
            } else {
                slide.setAttribute('aria-hidden', 'true');
                slide.querySelectorAll(FOCUSABLE).forEach((el) => el.setAttribute('tabindex', '-1'));
            }
        });
    }

    function initCrossSell() {
        const el = document.querySelector('.cross_sell_swiper');
        if (!el) return;

        if (typeof window.Swiper === 'undefined') {
            setTimeout(initCrossSell, 50);
            return;
        }

        const root = el.closest('.cross-sell-cart') || document;
        const nextEl = root.querySelector('.cross-sell-nav .swiper-button-next');
        const prevEl = root.querySelector('.cross-sell-nav .swiper-button-prev');

        if (el.swiper) {
            el.swiper.params.navigation.nextEl = nextEl;
            el.swiper.params.navigation.prevEl = prevEl;
            el.swiper.navigation.init();
            el.swiper.navigation.update();
            el.swiper.update();
            [nextEl, prevEl].forEach(btn => btn && btn.removeAttribute('aria-controls'));
            updateSlideVisibility(el.swiper);
            return;
        }

        const sw = new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: { nextEl, prevEl },
            observer: true,
            observeParents: true,
            resizeObserver: true,
            on: {
                init: updateSlideVisibility,
                slideChange: updateSlideVisibility,
                slideChangeTransitionEnd: updateSlideVisibility,
            },
        });

        [nextEl, prevEl].forEach(btn => btn && btn.removeAttribute('aria-controls'));
        setTimeout(() => sw.update(), 60);
    }

    document.addEventListener('DOMContentLoaded', initCrossSell);
    window.addEventListener('load', initCrossSell);

    ['cart:updated', 'cart:refresh', 'cart-drawer:open', 'shopify:section:load', 'shopify:section:select']
        .forEach(evt => document.addEventListener(evt, () => setTimeout(initCrossSell, 150)));

    const mo = new MutationObserver(() => setTimeout(initCrossSell, 150));
    mo.observe(document.body, { childList: true, subtree: true });
})();